module.exports = __webpack_public_path__ + "img/index_glzx3.9dcfe64f.png";